import React, { useState, Fragment } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";

import TarjetaVoto from "../components/tarjetavoto";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const BusquedaVoto = (props) => {
  const { municipio, onActualizarVoto } = props; // Recibe la función
  const [voto, guardarVoto] = useState();
  const [error, guardarError] = useState();

  const { register, handleSubmit } = useForm();

  const onSubmit = async (data, e) => {
    guardarVoto(null);
    guardarError(null);
    e.target.reset();
    if (data.busqueda === "") {
      return;
    }

    // Búsqueda del voto por DNI. Se limpia el número porque los votos se
    // guardan solo con dígitos: buscar "30.123.456" no encontraría nada.
    const dni = String(data.busqueda).replace(/\D/g, "");
    if (dni === "") {
      guardarError("Escribí un número de DNI.");
      return;
    }

    await axios
      .get(`/api/votos?municipioId=${municipio._id}&&dni=${dni}`)
      .then((res) => {
        if (res.data.votos[0]) {
          guardarVoto(res.data.votos[0]);
        } else {
          guardarError("No se encontró un voto con ese DNI.");
        }
      })
      .catch(() => {
        guardarError("Ocurrió un error.");
      });
  };

  const actualizarVoto = (idVoto, razonAnulado) => {
    if (voto && voto._id === idVoto) {
      const votoActualizado = { ...voto, anulado: true, razonAnulado };
      guardarVoto(votoActualizado);
      onActualizarVoto(idVoto, razonAnulado); // Actualiza en Fiscalizar
    }
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-md-12 mb-4">
          <form className="form-inline" onSubmit={handleSubmit(onSubmit)}>
            <input
              {...register("busqueda")}
              className="form-control"
              id="busqueda"
              placeholder="Ingresar DNI."
            />
            <button className="btn btn-sm form-control" type="submit">
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </form>
          {error && <small className="text-danger form-text">{error}</small>}
        </div>
      </div>
      {voto && (
        <div className="row">
          <div className="col-md-12">
            <TarjetaVoto
              key={voto._id}
              voto={voto}
              municipio={municipio}
              onAnular={actualizarVoto} // Pasa la función
            />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default BusquedaVoto;
